import { Inject, Injectable } from '@angular/core';

import { Severity } from 'core/logging/constants';
import { LoggingService } from 'core/logging/logging.service';
import { EventTrackingConfig } from './event-tracking-config';
import { GAEventTracker } from './google-analytics-event-tracker';
import { PostMessageEventTracker } from './post-message-event-tracker';

export interface TrackingObject
{
  category: string;
  action: string;
  label?: string;
  value?: number;
}

export interface EventTracker
{
  send(event: TrackingObject, autoEvent?: boolean): void;
}

@Injectable()
export class EventTrackingService
{
  private active: boolean = false;
  private eventTracker: EventTracker;

  public constructor(@Inject(LoggingService) private loggingService) {}

  public initializeTracking(tracking: EventTrackingConfig): void
  {
    switch (tracking.type) {
      case 'google_analytics':
        this.eventTracker = new GAEventTracker(
            tracking.id, tracking.conversionLabels);
        this.active = true;
        break;
      case 'post_message':
        this.eventTracker = new PostMessageEventTracker(
            tracking.targetOrigin);
        this.active = true;
        break;
      default:
        this.loggingService.log('EventTrackingService',
            Severity.ERROR, `tracking type ${tracking.type} not implemented`);
    }
  }

  public track(trackObject: TrackingObject, autoEvent: boolean = false): void
  {
    if (!this.active) {
      return;
    }

    this.eventTracker.send(trackObject, autoEvent);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/tracking/event-tracking.service.ts